import { createSelector } from 'reselect';
import BalanceOnHandPastInfoColumns from '../../containers/BalanceOnHandPastInfoColumns';
import TableDefinitions from '../../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.VIEW_BOH_PAST_INFO.isLoading;
export const getData = TableDefinitions.VIEW_BOH_PAST_INFO.getDataFunction();
export const getColumns = createSelector(getData, BalanceOnHandPastInfoColumns);
